import useSessionStorage from "./useSessionStorage";

import { useNavigate } from "react-router-dom";

const useAxios = (requiresAuth, on401) => {
  const [token, setToken] = useSessionStorage("token", "");
  const navigate = useNavigate();

  const buildUrl = (api) => {
    const baseUrl = process.env.REACT_APP_API_URL || '';
    const cleanBase = baseUrl.replace(/\/+$/, '');
    const cleanApi = api.replace(/^\/+/, '');
    return cleanBase + '/' + cleanApi;
  };

  const headers = {
    "Content-Type": "application/json",
  };

  if (requiresAuth === true) {
    headers["Authorization"] = "bearer " + token;
  }

  headers["Origin"] = window.location.origin;

  const get = async (api, onsuccess, onerror) => {
    try {
      const response = await fetch(buildUrl(api), {
        method: "GET",
        headers: headers,
      });

      if (response.ok) {
        const text = await response.text();
        if (!text.trim()) {
          onsuccess(null);
          return;
        }

        var json = JSON.parse(text);
        onsuccess(json);
      } else {
        if (response.status === 401 && on401) {
          on401();
        }

        if (onerror) {
          onerror();
        }
      }
    } catch (error) {
      console.error(error);
      if (onerror) {
        onerror(error);
      }
    }
  };
  const post = async (api, body, onsuccess, onerror) => {
    try {
      const response = await fetch(buildUrl(api), {
        method: "POST",
        headers: headers,
        body: JSON.stringify(body),
      });

      if (response.ok) {
        const text = await response.text();
        if (!text.trim()) {
          onsuccess(null);
          return;
        }

        var json = JSON.parse(text);
        onsuccess(json);
      } else {
        if (response.status === 401 && on401) {
          on401();
        }

        if (onerror) {
          onerror(await response.text());
        }
      }
    } catch (error) {
      if (onerror) {
        onerror(error);
      }
    }
  };

  const del = async (api, onsuccess, onerror) => {
    try {
      const response = await fetch(buildUrl(api), {
        method: "DELETE",
        headers: headers,
      });

      if (response.ok) {
        const text = await response.text();
        if (!text.trim()) {
          onsuccess(null);
          return;
        }

        var json = JSON.parse(text);
        onsuccess(json);
      } else {
        if (response.status === 401 && on401) {
          on401();
        }

        if (onerror) {
          onerror(await response.text());
        }
      }
    } catch (error) {
      if (onerror) {
        onerror(error);
      }
    }
  };

  const wrapper = {
    get: get,
    post: post,
    delete: del,
  };

  return [wrapper];
};

export default useAxios;
